/**
 * 下载讲义导出文件（PDF / Word）
 */
import { ExportQuotaError, EXPORT_QUOTA_EXCEEDED_CODE } from './teacherExportBilling'

async function parseJsonBody(res) {
  try {
    const text = await res.text()
    if (!text || !text.trim()) return null
    return JSON.parse(text)
  } catch (e) {
    return null
  }
}

function isQuotaExceeded(status, errBody) {
  if (status === 402) return true
  return errBody != null && Number(errBody.code) === EXPORT_QUOTA_EXCEEDED_CODE
}

async function handleFailedResponse(res, onError, onQuotaExceeded) {
  const errBody = await parseJsonBody(res)
  if (isQuotaExceeded(res.status, errBody)) {
    if (typeof onQuotaExceeded === 'function') {
      onQuotaExceeded(errBody || { code: EXPORT_QUOTA_EXCEEDED_CODE })
    }
    throw new ExportQuotaError(
      (errBody && errBody.message) || '讲义导出次数已用完，请购买后再试'
    )
  }
  if (typeof onError === 'function') onError()
  throw new Error((errBody && errBody.message) || '导出失败')
}

export async function downloadHandoutExport(handoutId, options = {}) {
  const {
    version = 'student',
    format = 'pdf',
    query = '',
    title = '讲义',
    contentHtml = '',
    apiBase = '/api/admin',
    onError,
    onQuotaExceeded
  } = options

  const versionLabel = version === 'teacher' ? '教师版' : '学生版'
  const ext = format === 'docx' ? 'docx' : 'pdf'
  const endpoint = format === 'docx' ? 'export-docx' : 'export-pdf'
  const fileAccept = format === 'docx'
    ? 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    : 'application/pdf'

  const token = localStorage.getItem('admin_token')
  const queryString = query ? (query.startsWith('?') ? query.slice(1) : query) : ''
  const url = `${apiBase}/handout/${handoutId}/${endpoint}${queryString ? `?${queryString}` : ''}`
  const usePost = !!contentHtml && (format === 'docx' || format === 'pdf')

  const fetchHeaders = {
    Authorization: `Bearer ${token}`,
    Accept: `${fileAccept}, application/json`
  }

  let res = await fetch(url, {
    method: usePost ? 'POST' : 'GET',
    headers: usePost ? { ...fetchHeaders, 'Content-Type': 'application/json' } : fetchHeaders,
    body: usePost ? JSON.stringify({ contentHtml }) : undefined
  })

  if (!res.ok) {
    if (usePost) {
      try {
        await handleFailedResponse(res.clone(), onError, onQuotaExceeded)
      } catch (e) {
        if (e instanceof ExportQuotaError) throw e
      }
      res = await fetch(url, { method: 'GET', headers: fetchHeaders })
    }
    if (!res.ok) {
      await handleFailedResponse(res, onError, onQuotaExceeded)
    }
  }

  const blob = await res.blob()
  const blobUrl = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = `${title || '讲义'}_${versionLabel}.${ext}`
  a.click()
  URL.revokeObjectURL(blobUrl)
  return { versionLabel, ext }
}
